import { simpleFetchWithHttp, simpleFetch } from './customFetch';

export const createGiftCard = (paymentInformation, recipient, sender, hCaptchaToken) =>
  simpleFetchWithHttp(
    '/gift-card-php',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'hcaptcha-token': hCaptchaToken,
      },
      body: JSON.stringify({
        paymentInformation,
        recipient,
        sender,
      }),
    },
    process.env.REACT_APP_GIFTING_API,
  );

export const getRedeemedGiftCards = () =>
  simpleFetch('/gift-cards-php', {}, process.env.REACT_APP_GIFTING_API);

export const redeemGiftCard = (redemptionCode) =>
  simpleFetch(
    '/redeem-gift-card-php',
    {
      method: 'POST',
      body: JSON.stringify({ redemptionCode }),
    },
    process.env.REACT_APP_GIFTING_API,
  );

export const getGiftCardsAmount = () =>
  simpleFetch('/api/1/gifts', {}, process.env.REACT_APP_LOCALIZATION_API);

export const getMembershipPrices = async () => {
  const { fffvip, fffvipa } = await simpleFetch(
    '/api/1/subscription/plans',
    {},
    process.env.REACT_APP_LOCALIZATION_API,
  );
  return { seasonalPrice: fffvip.price.amount, annualPrice: fffvipa.price.amount };
};
